<template>
  <div class="user-container" ref="usercontainer">
    <el-row class="user-button">

      <el-button type="primary" @click="dialogAddFormVisible = true"><i class="el-icon-plus"></i>新增用户</el-button>

    </el-row>
    <el-row class="user-con">
      <template >
        <el-table
            :data="tableData"
            style="width: 100%;height:100%;">
          <el-table-column
              prop="id"
              label="用户ID"
          >
          </el-table-column>
          <el-table-column
              prop="username"
              label="用户名"
          >
          </el-table-column>
          <el-table-column
              prop="nickname"
              label="昵称"
          >
          </el-table-column>
          <el-table-column
              prop="phone"
              label="电话号码"
          >
          </el-table-column>
          <el-table-column
              prop="adminId"
              label="管理员权限"

          >
          </el-table-column>
          <el-table-column
              label="所在部门"
          >
            <template  slot-scope="scope">{{ scope.row.deptId | deptIdToString}}</template>
          </el-table-column>
          <el-table-column
              label="操作"
          >
            <template slot-scope="scope">
              <el-row>
                <el-button type="primary" icon="el-icon-edit"  @click="openUpdate(scope.row.id)"></el-button>
                <el-button type="danger" icon="el-icon-delete"  @click="openDelete(scope.row.id)"></el-button>
              </el-row>
            </template>

          </el-table-column>
        </el-table>
      </template>
    </el-row>
    <el-row>
      <!-- Table -->


      <!--    新增用户-->
      <!-- Form -->
      <el-dialog title="新增用户" :visible.sync="dialogAddFormVisible">
        <el-form :model="addForm" style="text-align: left">
          <el-form-item label="用户名" :label-width="formLabelWidth">
            <el-input v-model="addForm.username" type="text" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="密码" :label-width="formLabelWidth">
            <el-input v-model="addForm.password" type="password" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="昵称" :label-width="formLabelWidth">
            <el-input v-model="addForm.nickname" type="text" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="手机号码" :label-width="formLabelWidth">
            <el-input v-model="addForm.phone" type="number" autocomplete="off"></el-input>
          </el-form-item>

          <el-form-item label="管理员权限" :label-width="formLabelWidth" style="width:60%">
            <el-select v-model="addForm.adminId" placeholder="请选择权限" >
              <el-option label="超级管理员" value= "0" ></el-option>
              <el-option label="东北抗日义勇军纪念馆" value= "1"></el-option>
              <el-option label="李秋实纪念馆" value= "2"></el-option>
              <el-option label="桓仁抗战红都教育服务中心" value= "3"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="部门名称" :label-width="formLabelWidth" style="width:60%">
            <el-select v-model="addForm.deptId" placeholder="请选择所在部门" >
              <el-option label="东北抗日义勇军纪念馆" value="1"></el-option>
              <el-option label="李秋实纪念馆" value="2"></el-option>
              <el-option label="桓仁抗战红都教育服务中心" value="3"></el-option>
            </el-select>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="clearForm()" >取 消</el-button>
          <el-button type="primary" @click="addSubmit(addForm)">确 定</el-button>
        </div>
      </el-dialog>
      <!-- Form -->


      <!-- Form -->
      <el-dialog title="修改用户" :visible.sync="dialogFormVisible">
        <el-form :model="form">
          <el-form-item label="修改用户名" :label-width="formLabelWidth">
            <el-input v-model="form.username"  type="text" autocomplete="off"></el-input>
          </el-form-item>
<!--          <el-form-item label="修改密码" :label-width="formLabelWidth">-->
<!--            <el-input v-model="form.password"  type="password" autocomplete="off"></el-input>-->
<!--          </el-form-item>-->
          <el-form-item label="修改电话" :label-width="formLabelWidth">
            <el-input v-model="form.phone"  type="number" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="修改昵称" :label-width="formLabelWidth">
            <el-input v-model="form.nickname" type="text" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item  label="修改管理员权限" :label-width="formLabelWidth"  style="width:40%">
            <el-select v-model="form.adminId" placeholder="请选择用户管理员权限" ref="adminId">
              <el-option label="超级管理员" value= "0" ></el-option>
              <el-option label="东北抗日义勇军纪念馆" value= "1"></el-option>
              <el-option label="李秋实纪念馆" value= "2"></el-option>
              <el-option label="桓仁抗战红都教育服务中心" value= "3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item  label="修改部门" :label-width="formLabelWidth"  style="width:40%">
            <el-select v-model="form.deptId" placeholder="请选择用户所在部门" ref="deptId">
              <el-option label="东北抗日义勇军纪念馆" value="1"></el-option>
              <el-option label="李秋实纪念馆" value="2"></el-option>
              <el-option label="桓仁抗战红都教育服务中心" value="3"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="upDateAdd(form)">确 定</el-button>
        </div>
      </el-dialog>
    </el-row>
    <div class="block">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage1"
          :page-size="pageSize"
          layout="total, prev, pager, next"
          :total="total">
      </el-pagination>
    </div>

  </div>
</template>

<script>


import {request} from "@/request/request";


export default {
  name: "UserAdmin",
  data() {
    return {
      tableData: [],
      total:0,
      pageSize:100,
      currentPage1: 5,
      currentPage2: 5,
      currentPage3: 5,
      currentPage4: 4,
      dialogAddFormVisible:false,
      dialogFormVisible:false,
      dialogTableVisible: false,
      addForm:{

      },
      form:{


      },
      formLabelWidth: '120px',
    }
  },
  methods:{
    addSubmit(data){
      this.addForm.deptId = parseInt(this.addForm.deptId);
      this.addForm.adminId = parseInt(this.addForm.adminId);

      request({
        method:'POST',
        url:'/users',
        data:data
      }).then(res =>{
        if(res.code == 1){
          this.$message({
            type: 'success',
            message: '新增成功!',
          });
          this.getUser();
          this.addForm = {};
          this.dialogAddFormVisible = false;
        }
      },err=>{
        console.log(err)
      })
    },
    clearForm(){
      this.addForm = {};
      this.dialogAddFormVisible = false;
    },






    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    openUpdate(uid){
      this.form.id = uid;

      this.getUserById(uid);




      this.dialogFormVisible = true;

    },
    upDateAdd:function(formData){

      request({
        method:'PUT',
        url:'/users',
        data:formData
      }).then(res =>{
        if(res.code==1){
          this.$message({
            type: 'success',
            message: '修改成功!',
          });
          this.getUser();
        }
      },err=>{
        console.log(err)
      })
      this.dialogFormVisible = false;
    },
    openDelete(uid) {
      this.$confirm('此操作将永久删除该, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          //删除用户请求
          request({
            method:'DELETE',
            url:'/users/'+uid,
          }).then(res =>{
            if(res.code==1){
              this.$message({
                type: 'success',
                message: '删除成功!',
              });
              this.getUser();
            }
          },err=>{
            console.log(err)
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    getUser:function(){
      request({
        method:'GET',
        url:'/users',
      }).then(res =>{
        this.tableData = res.data;
      },err=>{
        console.log(err)
      })
    },
    getUserById:function(userId){
      request({
        method:'GET',
        url:'/users/'+userId,
      }).then(res =>{

        this.form = res.data;
        console.log(this.form)

      },err=>{
        console.log(err)
      })
    },

  },
  mounted() {
    // this.$refs.usercontainer.style = 'height:'+ window.innerHeight-60 + 'px';
    this.getUser();

    request({
      method:'GET',
      url:'/users/count',
    }).then(res =>{

      this.total = res.data;
    },err=>{
      console.log(err)
    })

  },
  filters:{
    deptIdToString(id){
      var newId = '';
      if(id ==0){
        newId = '桓仁红色教育服务中心';
        return newId
      }
      if(id ==1){
        newId = '东北抗日义勇军纪念馆';
        return newId
      }
      if(id ==2){
        newId = '李求实纪念馆';
        return newId
      }
      if(id ==3){
        newId = '桓仁抗战红都服务中心';
        return newId
      }

    },
  },
}


</script>

<style scoped>
.user-button{
  text-align: left;
  padding:0 10px 10px;
  border-bottom: 1px solid rgb(165,165,165);
}
.user-container{
  height:100%;
}
.user-con{
  padding:40px;
}
</style>
